import { Form, Formik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../../Icon/Icon";
import { Button } from "../../Button/Button";
import { EditableInformationTextInput } from "../EditableInformation";
import "./EditableInformationText.css";

/**
 *
 *
 * @param {object} props
 * @prop {string} label
 * @prop {string} value
 * @prop {boolean} [editable]
 * @prop {boolean} [defaultEditingState]
 * @prop {function} onSubmit
 * @prop {function} [validationSchema]
 * @prop {string} name
 *
 * @return {*}
 */
export const EditableInformationText = ({
  label,
  value,
  editable = true,
  defaultEditingState = false,
  onSubmit,
  validationSchema,
  name,
}) => {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(defaultEditingState);
  return (
    <div
      className={
        isEditing
          ? "EditableInformationDisplay EditableInformationDisplay--editing"
          : "EditableInformationDisplay"
      }
    >
      <div className="EditableInformationDisplay__label">
        <div className="EditableInformationDisplay__label--text">
          {t(label)}
        </div>
      </div>
      <div
        className="EditableInformationDisplay__value"
        style={{ paddingLeft: !isEditing ? "14px" : "0px" }}
      >
        {!isEditing && (
          <div className="EditableInformationDisplay__value--text">{value}</div>
        )}
        {isEditing && (
          <Formik
            initialValues={{
              [name]: value,
            }}
            onSubmit={(data) => {
              setIsEditing(false);
              onSubmit(data);
            }}
            validationSchema={validationSchema}
          >
            {({ isValid, dirty }) => {
              return (
                <Form
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <div className="EditableInformationDisplay__value EditableInformationDisplay__value--editing">
                    <EditableInformationTextInput
                      name={name}
                      type="text"
                      defaultEditingState={true}
                    />
                  </div>
                  <div className="EditableInformationDisplay__action">
                    <Button
                      buttonStyle="EditableInformationDisplay__action-button"
                      click={() => setIsEditing(false)}
                    >
                      <Icon name="iconCross" width={14} height={14} />
                    </Button>
                    <Button
                      buttonStyle="EditableInformationDisplay__action-button"
                      type="submit"
                      disabled={!isValid || !dirty}
                    >
                      <Icon name="iconCheckmark" width={14} height={18} />
                      <div className="EditableInformationDisplay__action-button-text">
                        {t("generic.save")}
                      </div>
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        )}
      </div>
      {editable && (
        <div
          className="EditableInformationDisplay__action"
          onClick={() => setIsEditing(true)}
        >
          {!isEditing && <Icon name="iconEdit" width={14} height={18} />}
        </div>
      )}
    </div>
  );
};
